export type BiodynamicDayType = 'root' | 'flower' | 'fruit' | 'leaf';
export type MoonPhase = 'new' | 'waxing-crescent' | 'first-quarter' | 'waxing-gibbous' | 'full' | 'waning-gibbous' | 'last-quarter' | 'waning-crescent';
export type ZodiacSign = 'aries' | 'taurus' | 'gemini' | 'cancer' | 'leo' | 'virgo' | 'libra' | 'scorpio' | 'sagittarius' | 'capricorn' | 'aquarius' | 'pisces';
export type PreparationType = '500' | '501' | '502' | '503' | '504' | '505' | '506' | '507' | '508';
export type ApplicationArea = 'vegetable-garden' | 'farm' | 'vineyard' | 'orchard' | 'compost';

export interface BiodynamicDay {
  date: string; // ISO date
  dayType: BiodynamicDayType;
  moonPhase: MoonPhase;
  zodiacSign: ZodiacSign;
  moonAscending: boolean;
  notes?: string;
}

export interface BiodynamicPreparation {
  id: PreparationType;
  name: string;
  commonName: string;
  ingredients: string[];
  description: string;
  howToMake: string;
  howToUse: string;
  applicationAreas: ApplicationArea[];
  timing: string;
  benefits: string[];
  imageUrl?: string;
}

export interface BiodynamicCalendarEntry {
  month: number;
  year: number;
  days: BiodynamicDay[];
}

export const ZODIAC_TO_DAY_TYPE: Record<ZodiacSign, BiodynamicDayType> = {
  aries:       'fruit',
  taurus:      'root',
  gemini:      'flower',
  cancer:      'leaf',
  leo:         'fruit',
  virgo:       'root',
  libra:       'flower',
  scorpio:     'leaf',
  sagittarius: 'fruit',
  capricorn:   'root',
  aquarius:    'flower',
  pisces:      'leaf',
};

export const MOON_PHASE_EMOJI: Record<MoonPhase, string> = {
  'new':             '🌑',
  'waxing-crescent': '🌒',
  'first-quarter':   '🌓',
  'waxing-gibbous':  '🌔',
  'full':            '🌕',
  'waning-gibbous':  '🌖',
  'last-quarter':    '🌗',
  'waning-crescent': '🌘',
};

export const DAY_TYPE_META: Record<BiodynamicDayType, { label: string; emoji: string; color: string; description: string }> = {
  root:   { label: 'Root Day',   emoji: '🌱', color: 'terracotta', description: 'Best for root vegetables — carrots, beetroot, potatoes, onions' },
  flower: { label: 'Flower Day', emoji: '🌸', color: 'rose',       description: 'Best for flowering plants, brassicas and herbs' },
  fruit:  { label: 'Fruit Day',  emoji: '🍅', color: 'ochre',      description: 'Best for fruiting plants — tomatoes, courgettes, beans, apples' },
  leaf:   { label: 'Leaf Day',   emoji: '🥬', color: 'sage',       description: 'Best for leafy greens — lettuce, spinach, chard, herbs for leaf' },
};
